import { DocumentTitle } from './DocumentTitle';

export default DocumentTitle;
